import api from '@/lib/api';

export interface CitySearchResult {
  id: number;
  name: string;
  postalCode: string;
  departement: string;
  departementCode: string;
  departementId: number;
  regionId: number | null;
  regionName: string | null;
  countryId: number;
  latitude: number | null;
  longitude: number | null;
}

export interface DepartementDto {
  id: number;
  code: string;
  name: string;
  countryId: number;
  regionId: number | null;
  regionName: string | null;
}

export interface RegionDto {
  id: number;
  code: string;
  name: string;
  countryId: number;
}

export interface CountryDto {
  id: number;
  alpha2: string;
  nameFr: string;
  nameEn: string;
}

const BASE_URL = '/geography';

export const geographyService = {
  async searchCities(query: string, limit: number = 15): Promise<CitySearchResult[]> {
    const { data } = await api.get(`${BASE_URL}/cities/search?q=${encodeURIComponent(query)}&limit=${limit}`);
    return data;
  },

  async listDepartements(countryId: number = 1): Promise<DepartementDto[]> {
    const { data } = await api.get(`${BASE_URL}/departements?countryId=${countryId}`);
    return data;
  },

  async listRegions(countryId: number = 1): Promise<RegionDto[]> {
    const { data } = await api.get(`${BASE_URL}/regions?countryId=${countryId}`);
    return data;
  },

  async listCountries(): Promise<CountryDto[]> {
    const { data } = await api.get(`${BASE_URL}/countries`);
    return data;
  },
};
